// 登录模块多语言配置
export const login = {
  'zh-CN': {
    accountLogin: '账号登录',
    phoneLogin: '手机号登录',
    emailLogin: '邮箱登录',
    inputEmail: '请输入邮箱地址',
    selectCompany: '请选择公司',
    inputPassword: '请输入密码',
    forgotPassword: '忘记密码',
    freeRegister: '免费注册体验',
    login: '登录',
    
    // 体验登录相关
    experienceRegister: '注册体验',
    verificationCode: '请输入验证码',
    getVerificationCode: '获取验证码',
    resend: '重新发送',
    haveAccountLogin: '已有账号，去登录',
    experienceNow: '立即体验',
    
    // 忘记密码相关
    forgotPasswordTitle: '忘记密码',
    phoneRetrieval: '手机号找回',
    emailRetrieval: '邮箱找回',
    securityVerification: '安全验证',
    setNewPassword: '设置新密码',
    setSuccess: '设置成功',
    nextStep: '下一步',
    loginImmediately: '立即登录',
    freeRegisterExperience: '免费注册体验',
    backToLogin: '返回登录',
    
    // 验证相关
    inputPhoneNumber: '请输入手机号',
    inputEmailAddress: '请输入邮箱地址',
    selectCompanyPlaceholder: '请选择公司',
    imageVerificationCode: '图形验证码',
    smsVerificationCode: '短信验证码',
    emailVerificationCode: '邮箱验证码',
    inputNewPassword: '请输入新密码',
    repeatNewPassword: '请重复新密码',
    
    // 错误消息
    warning: '警告',
    pleaseEnterCorrectEmail: '请输入正确的邮箱地址',
    phoneNotRegistered: '此手机号未注册，请输入已注册手机号或点击免费注册体验可免费体验查看',
    emailNotRegistered: '此邮箱未注册，请输入已注册邮箱或点击免费注册体验可免费体验查看',
    incompleteAccountInfo: '账号信息不完整，请填写完整',
    phoneOrCodeEmpty: '手机号或验证码为空',
    emailOrCodeEmpty: '邮箱或验证码为空',
    passwordTooShort: '密码长度不得小于六位',
    passwordsNotMatch: '两次输入的密码不一，请重新输入',
    
    // 成功消息
    passwordSetSuccess: '设置成功',
    
    // 其他
    oemConfigError: 'oem配置错误,请联系售后',
    defaultTitle: '睿哲智能CRM'
  },
  'zh-TW': {
    accountLogin: '賬號登錄',
    phoneLogin: '手機號登錄',
    emailLogin: '郵箱登錄',
    inputEmail: '請輸入郵箱地址',
    selectCompany: '請選擇公司',
    inputPassword: '請輸入密碼',
    forgotPassword: '忘記密碼',
    freeRegister: '免費註冊體驗',
    login: '登錄',
    
    // 體驗登錄相關
    experienceRegister: '註冊體驗',
    verificationCode: '請輸入驗證碼',
    getVerificationCode: '獲取驗證碼',
    resend: '重新發送',
    haveAccountLogin: '已有賬號，去登錄',
    experienceNow: '立即體驗',
    
    // 忘記密碼相關
    forgotPasswordTitle: '忘記密碼',
    phoneRetrieval: '手機號找回',
    emailRetrieval: '郵箱找回',
    securityVerification: '安全驗證',
    setNewPassword: '設置新密碼',
    setSuccess: '設置成功',
    nextStep: '下一步',
    loginImmediately: '立即登錄',
    freeRegisterExperience: '免費註冊體驗',
    backToLogin: '返回登錄',
    
    // 驗證相關
    inputPhoneNumber: '請輸入手機號',
    inputEmailAddress: '請輸入郵箱地址',
    selectCompanyPlaceholder: '請選擇公司',
    imageVerificationCode: '圖形驗證碼',
    smsVerificationCode: '短信驗證碼',
    emailVerificationCode: '郵箱驗證碼',
    inputNewPassword: '請輸入新密碼',
    repeatNewPassword: '請重複新密碼',
    
    // 錯誤消息
    warning: '警告',
    pleaseEnterCorrectEmail: '請輸入正確的郵箱地址',
    phoneNotRegistered: '此手機號未註冊，請輸入已註冊手機號或點擊免費註冊體驗可免費體驗查看',
    emailNotRegistered: '此郵箱未註冊，請輸入已註冊郵箱或點擊免費註冊體驗可免費體驗查看',
    incompleteAccountInfo: '賬號信息不完整，請填寫完整',
    phoneOrCodeEmpty: '手機號或驗證碼為空',
    emailOrCodeEmpty: '郵箱或驗證碼為空',
    passwordTooShort: '密碼長度不得小於六位',
    passwordsNotMatch: '兩次輸入的密碼不一，請重新輸入',
    
    // 成功消息
    passwordSetSuccess: '設置成功',
    
    // 其他
    oemConfigError: 'oem配置錯誤,請聯繫售後',
    defaultTitle: '睿哲智能CRM'
  },
  'en': {
    accountLogin: 'Account Login',
    phoneLogin: 'Phone Login',
    emailLogin: 'Email Login',
    inputEmail: 'Please enter email address',
    selectCompany: 'Please select company',
    inputPassword: 'Please enter password',
    forgotPassword: 'Forgot Password',
    freeRegister: 'Free Registration',
    login: 'Login',
    
    // Experience Login
    experienceRegister: 'Experience Registration',
    verificationCode: 'Please enter verification code',
    getVerificationCode: 'Get Code',
    resend: 'Resend',
    haveAccountLogin: 'Have account? Login',
    experienceNow: 'Experience Now',
    
    // Forgot Password
    forgotPasswordTitle: 'Forgot Password',
    phoneRetrieval: 'Phone Retrieval',
    emailRetrieval: 'Email Retrieval',
    securityVerification: 'Verification',
    setNewPassword: 'Set New Password',
    setSuccess: 'Set Success',
    nextStep: 'Next Step',
    loginImmediately: 'Login Immediately',
    freeRegisterExperience: 'Free Registration',
    backToLogin: 'Back to Login',
    
    // Verification
    inputPhoneNumber: 'Please enter phone number',
    inputEmailAddress: 'Please enter email address',
    selectCompanyPlaceholder: 'Please select company',
    imageVerificationCode: 'Image Verification Code',
    smsVerificationCode: 'SMS Verification Code',
    emailVerificationCode: 'Email Verification Code',
    inputNewPassword: 'Please enter new password',
    repeatNewPassword: 'Please repeat new password',
    
    // Error Messages
    warning: 'Warning',
    pleaseEnterCorrectEmail: 'Please enter correct email address',
    phoneNotRegistered: 'This phone number is not registered. Please enter a registered phone number or click free registration to experience',
    emailNotRegistered: 'This email is not registered. Please enter a registered email or click free registration to experience',
    incompleteAccountInfo: 'Account information incomplete, please fill in completely',
    phoneOrCodeEmpty: 'Phone number or verification code is empty',
    emailOrCodeEmpty: 'Email or verification code is empty',
    passwordTooShort: 'Password length must be at least 6 characters',
    passwordsNotMatch: 'The two passwords do not match, please re-enter',
    
    // Success Messages
    passwordSetSuccess: 'Set Success',
    
    // Other
    oemConfigError: 'OEM configuration error, please contact after-sales',
    defaultTitle: 'Ruizhe Smart CRM'
  }
}; 